// client/types.ts
import "@adornis/chemistry/elements/components/x-icon";
var MenuItemGroup = /* @__PURE__ */ ((MenuItemGroup2) => {
  MenuItemGroup2["TEXT_STYLE"] = "text-style";
  MenuItemGroup2["TEXT_ALIGNMENT"] = "text-aignment";
  MenuItemGroup2["HEADINGS"] = "headings";
  MenuItemGroup2["COLOR"] = "color";
  MenuItemGroup2["LAYOUT"] = "layout";
  MenuItemGroup2["MEDIA"] = "media";
  MenuItemGroup2["BASIC"] = "basic";
  MenuItemGroup2["SETTINGS"] = "settings";
  return MenuItemGroup2;
})(MenuItemGroup || {});
export {
  MenuItemGroup
};
